import React from "react";
import ImageMobile from "./ImageMobile";
import { FeatureModuleDetailType } from "../types/FeatureModuleDetail";
import { CtaButton } from "../Cta/cta-button";

const ModuleDetailMobile = ({ feature, onClick }: FeatureModuleDetailType) => {
  return feature?.map((item, key) => {
    const imageObject = item?.mobileAsset;

    return (
      <div
        className="feature-module md:block hidden feature-module--mobile px-10 sm:px-5 mb-16 sm:mb-12 redesign-component"
        key={key}
      >
        <ImageMobile
          imageObject={imageObject}
          backgroundColor={item?.backgroundColor}
        />
        <div className="header4">
          <h4
            className="text-left pb-2"
            dangerouslySetInnerHTML={{ __html: item.headline }}
          />
          <p
            className="feature-module__text body--text-regular text-left"
            dangerouslySetInnerHTML={{
              __html: item.Subcopy,
            }}
          />
          <div className="flex">
            {item?.ctaCopy && (
              <div className="mt-6">
                <CtaButton
                  variant="tertiarySun"
                  copy={item.ctaCopy}
                  copySize="bodyRegular"
                  isDisabled={false}
                  link={item?.ctaLink?.value?.data?.url || null}
                  linkUrl={item?.ctaUrl || null}
                  onClick={onClick}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    );
  });
};

export default ModuleDetailMobile;
